// extracted by mini-css-extract-plugin
module.exports = {"fallback_container":"ErrorFallback_fallback_container__PO6j2","fallback_info":"ErrorFallback_fallback_info__Jw44S"};